// First-party cookie consent: storage, route scoping and gated script loading.
export const CONSENT_COOKIE = "cookie_consent";
const CONSENT_MAX_AGE = 60 * 60 * 24 * 365; // 12 months

// Routes where no banner shows and no optional script may ever load:
// the logged-in app, auth/transactional pages and client intake.
const NON_MARKETING_PREFIXES = [
    "/dashboard", "/clients", "/portal", "/auditor", "/admin", "/payment",
    "/mfa-setup", "/login", "/register", "/forgot-password", "/reset-password",
    "/verify-email", "/intake",
];

export function isPublicMarketingPath(pathname) {
    return !NON_MARKETING_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(p));
}

export function getConsent() {
    const m = document.cookie.match(/(?:^|;\s*)cookie_consent=([^;]*)/);
    const v = m ? decodeURIComponent(m[1]) : null;
    return v === "accepted" || v === "rejected" ? v : null;
}

export function setConsent(value) {
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(value)}; Max-Age=${CONSENT_MAX_AGE}; Path=/; SameSite=Lax${secure}`;
    window.dispatchEvent(new CustomEvent("cookie-consent-changed", { detail: value }));
    if (value === "accepted") loadOptionalScripts();
    else revokeOptionalScripts();
}

let pixelLoaded = false;

// Loads optional third-party scripts (Meta Pixel) ONLY when all gates pass:
// explicit Accept consent, a public marketing route, and a configured pixel ID.
export function loadOptionalScripts() {
    if (getConsent() !== "accepted") return;
    if (!isPublicMarketingPath(window.location.pathname)) return;
    const pixelId = process.env.REACT_APP_META_PIXEL_ID;
    if (!pixelId) return; // no pixel configured — nothing to load
    if (pixelLoaded) {
        if (window.fbq) window.fbq("consent", "grant");
        return;
    }
    pixelLoaded = true;
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n;
        n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
        t = b.createElement(e); t.async = true; t.src = v;
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("consent", "grant");
    window.fbq("init", pixelId);
    window.fbq("track", "PageView");
}

// Best-effort kill switch for an already-loaded pixel (full removal happens
// on the next page load, when the consent gate blocks it entirely).
export function revokeOptionalScripts() {
    if (window.fbq) window.fbq("consent", "revoke");
}

export const openCookieSettings = () => window.dispatchEvent(new Event("open-cookie-settings"));
